import { GetSplashScreenModel } from "@factory/model/query-model-splash-screen";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { splashScreenFormDefault } from "./form.default";
import { SplashScreenFormSchema } from "./form.rule";

export const useFormDefaultSplashScreen = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetSplashScreenModel | undefined) => {
    return !cachedValue
      ? splashScreenFormDefault
     : ({
        name: cachedValue.name,
        tenant: cachedValue.tenant,
        image: cachedValue.image,
        description: cachedValue.description,
        link: cachedValue.link,
      } as SplashScreenFormSchema);
  };

  return {
    getDefault,
  };
};
